module.exports = __webpack_public_path__ + "mo/img/ad01.2cd40cfe.png";